import _regeneratorRuntime from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Alert from '@/components/shared/Alert';
import Panel from '@/components/shared/Panel';
import FilterManagementTable from '@/components/filter-management/FilterManagementTable';
import { SearchFilter } from '@/services/ResourceService';
import moment from 'moment';
import ConfirmService from '@/services/ConfirmService';
export default {
  name: 'FilterManagementPanel',
  components: {
    Panel: Panel,
    Alert: Alert,
    FilterManagementTable: FilterManagementTable
  },
  data: function data() {
    return {
      isLoading: false,
      errorOccurred: false,
      filter: '',
      filters: []
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$SearchFilter$g, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.isLoading = true;
              _context.prev = 1;
              _context.next = 4;
              return SearchFilter.getAll(_this.$store.state.general.selectedUser.id);
            case 4:
              _yield$SearchFilter$g = _context.sent;
              data = _yield$SearchFilter$g.data;
              _this.isLoading = false;
              _this.filters = data.map(function (f) {
                return {
                  id: f.id,
                  name: f.name,
                  locations: f.locations.map(function (l) {
                    return l.name;
                  }),
                  locationGroups: f.locationGroups.map(function (lg) {
                    return lg.name;
                  }),
                  createdDate: f.createdDate === null ? null : moment(f.createdDate),
                  lastModifiedDate: f.lastModifiedDate === null ? null : moment(f.lastModifiedDate)
                };
              });
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              _this.errorOccurred = true;
              _this.isLoading = false;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 10]]);
      }))();
    },
    requestDeleteFilter: function requestDeleteFilter(filter) {
      var _this2 = this;
      ConfirmService.createModal({
        name: 'confirm-delete-filter',
        type: 'danger',
        title: this.$t('requestDeleteModal.title'),
        icon: ['fas', 'exclamation-triangle'],
        text: this.$t('requestDeleteModal.text', {
          filterName: filter.name
        }),
        textIsHtml: true,
        okayButton: this.$t('requestDeleteModal.okay'),
        dismissButton: this.$t('requestDeleteModal.dismiss'),
        onClose: function onClose(param) {
          if (param && param.okay) {
            _this2.deleteFilter(filter.id);
          }
        }
      });
    },
    deleteFilter: function deleteFilter(filterId) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoading = true;
              _context2.prev = 1;
              _context2.next = 4;
              return SearchFilter.deleteSearchFilter(_this3.$store.state.general.selectedUser.id, filterId);
            case 4:
              _context2.next = 9;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              _this3.errorOccurred = true;
            case 9:
              _this3.isLoading = false;
              _context2.next = 12;
              return _this3.loadData();
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 6]]);
      }))();
    }
  }
};